module.exports = __webpack_public_path__ + "static/media/pay-payatcounter-on.91d0eba0.png";